import React from 'react';
import Hero from '../../components/ui/Hero';
import { Store } from 'lucide-react';

const StorePage = () => {
  return (
    <div>
      <Hero
        title="Animatronic Store"
        description="Coming Soon - Official merchandise and collectibles"
        compact
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <Store className="w-16 h-16 text-brand mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-content-primary mb-4">
            Store Coming Soon!
          </h2>
          <p className="text-content-secondary max-w-2xl mx-auto">
            Get ready to shop for exclusive animatronic merchandise, collectibles, and more. 
            Our store will feature unique items for animatronic enthusiasts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StorePage;